module.exports = __webpack_public_path__ + "img/Configuration2.42be0770.jpg";